import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './IncomePage.scss';

const IncomePage = () => {
  return (
    <div className="IncomePage">
      <ComingSoon title="IncomePage" />
    </div>
  );
};

export default IncomePage;